export default "__VITE_ASSET__4606f886__"